const riot = require('riot');
riot.tag2('stats', '<div class="card"> <div class="card-content"> <div class="field is-grouped is-flexwrap"> <div class="control"> <label class="label">Collection</label> <div class="select is-small"> <select ref="collection" name="collection" onchange="{setCollection}"> <option value="counters" selected="{state.collection==\'counters\'}">counters</option> <option value="counters_alt" selected="{state.collection==\'counters_alt\'}">counters_alt</option> </select> </div> </div> <div class="control"> <label class="label">Time period</label> <div class="select is-small"> <select ref="period" name="period" onchange="{setPeriod}"> <option value="last7" selected="{state.period==\'last7\'}">Last 7 days</option> <option value="last30" selected="{state.period==\'last30\'}">Last 30 days</option> <option value="month" selected="{state.period==\'month\'}">Previous month</option> <option value="custom" selected="{state.period==\'custom\'}">Custom</option> </select> </div> </div> <div class="control"> <label class="label">Start date</label> <input class="input is-small" ref="start_date" onchange="{setStartDate}" riot-value="{state.start_date}" placeholder="Start Date" title="Start date" type="{\'date\'}"> </div> <div class="control"> <label class="label">End date</label> <input class="input is-small" ref="end_date" onchange="{setEndDate}" riot-value="{state.end_date}" placeholder="End Date" title="End date" type="{\'date\'}"> </div> <div class="control"> <label class="label">&nbsp;</label> <input type="submit" class="button is-small {is-warning:state.dirty}" onclick="{submit}" value="Refresh"> </div> </div> <div class="field columns"> <div class="column"> <label class="label">Active dimensions</label> <virtual each="{dim, i in state.picked}"> <button class="button is-info is-small" onclick="{stash}">{dim}</button> </virtual> </div> <div class="column"> <label class="label">Inactive dimensions</label> <virtual each="{dim, i in state.stashed}"> <button class="button is-small" onclick="{pick}">{dim}</button> </virtual> </div> </div> </div> </div> <p>&nbsp;</p> <h3 class="title is-5">Performance report</h3> <div data-is="groupy" start="{state.start_date}" end="{state.end_date}T23:59:59" dimensions="{state.picked}"> </div>', 'stats .metric span,[data-is="stats"] .metric span{ font-size:80%; color: darkred }', '', function(opts) {
  var self = this,
      now = new Date(),
      day = now.getDate(),
      month = now.getMonth(),
      year = now.getFullYear(),
      today = new Date(year,month,day,12),
      ago7 = new Date(today.valueOf() - 7*24*3600*1000),
      ago30 = new Date(today.valueOf() - 30*24*3600*1000),
      month_start = new Date(year,month,1,12),
      last_start = month>0 ? new Date(year,month-1,1,12) : new Date(year-1,12+month-1,1,12),
      last_end = new Date(month_start.valueOf() - 24*3600*1000)

  var filters = api.get('filters'),
      state = filters['stats'] = filters['stats'] || {
        start_date: ago7.toISOString().replace(/T.*$/,''),
        end_date: today.toISOString().replace(/T.*$/,''),
        picked: ['_id.campaign','_id.host','_id.widget','_id.segment'],
        stashed: ['_id.month','_id.week','_id.date','_id.hour','_id.doc','_id.retarget'],
        period: 'last7',
        collection: 'counters',
        dirty: false
      }

  self.state = state

  self.title_style = 0

  this.setStartDate = function(e) {
    e.preventDefault()
    state.start_date = self.refs.start_date.value
    state.period = 'custom'
    state.dirty = true
    console.log('state.start_date',state.start_date)
  }.bind(this)
  this.setEndDate = function(e) {
    e.preventDefault()
    state.end_date = self.refs.end_date.value
    state.period = 'custom'
    state.dirty = true
    console.log('state.end_date',state.end_date)
  }.bind(this)
  this.setCollection = function(e) {
    state.collection = self.refs.collection.value
    state.dirty = true
  }.bind(this)
  this.setPeriod = function(e) {
    state.period = e.target.value
    switch (state.period) {
      case 'month':
        state.start_date = last_start.toISOString().replace(/T.*$/,'')
        state.end_date = last_end.toISOString().replace(/T.*$/,'')
        break;
      case 'last30':
        state.start_date = ago30.toISOString().replace(/T.*$/,'')
        state.end_date = today.toISOString().replace(/T.*$/,'')
        break;
      case 'custom':
        break;
      case 'last7':
      default:
        state.start_date = ago7.toISOString().replace(/T.*$/,'')
        state.end_date = today.toISOString().replace(/T.*$/,'')
    }
    state.dirty = true
  }.bind(this)

  const ce_admins = ["gr","ug","ughr","si","adria","bg","hu","ba","cz","sk","ads"];
  self.dimension_service = {

    '_id.campaign': {oid: true, action: ids => api.service('campaigns').find({query:{_id:{$in:ids},$select:['name'],$limit:ids.length}}).then(r => {
      console.log('campaign lookup',ids,r)
      return r.data
    }) },
    '_id.doc': {oid: false, action: (ids,filter) => {
      var cf = filter['_id.campaign'],
          camp = ce_admins.indexOf(cf)<0 ? '' : '_'+cf;
      return api.service('posts'+camp).find({query:{_id:{$in:ids},$select:['name'],$limit:ids.length}}).then(r => {
        console.log('post lookup',ids,r)
        return r.data.map( d => {
          var admin_url = camp ? 'admin_'+camp : 'admin_demo',
              link = `https://${admin_url}.contentexchange.me/posts/${d._id}/edit`;
          return {_id: d._id,name: (camp || 'bex')+'#'+d._id,title: d.name, link: link}
        })
      })
    }},
    '_id.segment': {oid: true, action: ids => api.service('audiences').find({query:{_id:{$in:ids},$select:['name'],$limit:ids.length}}).then(r => {
      console.log('audience lookup',ids,r)
      return r.data
    }) },
    '_id.widget': { oid: false, action: ids => {
      return api.service('ce-widgets').find({query:{"_id.id":{$in:ids},$select:['name'],$limit:5000}}).then(r => {
        console.log('widgets lookup',ids)
        var widgetDict = {}
        return r.data.map( d => {
          var admin_url = d._id.admin=='bexrt' ? '' : d._id.admin=='si' ? 'admin' : 'admin_'+d._id.admin,
              link = d._id.admin=='bexrt' ? '' : `https://${admin_url}.contentexchange.me/widgets/${d._id.id}/edit`;
          return {_id: d._id.id,name: d._id.admin+'#'+d._id.id,title: d.name, link: link}
        })
      })
    }}
  }
  this.pick = function(e) {
    e.preventDefault()
    state.stashed = state.stashed.filter(d => d!=e.item.dim)
    state.picked.push(e.item.dim)
    state.dirty = true
  }.bind(this)
  this.stash = function(e) {
    e.preventDefault()
    state.picked = state.picked.filter(d => d!=e.item.dim)
    state.stashed.push(e.item.dim)
    state.dirty = true
  }.bind(this)
  this.submit = function(e) {
    e.preventDefault()
    state.dirty = false
    self.tags.groupy.trigger( 'filter', {start:state.start_date,end:state.end_date,dimensions:state.picked} )
  }.bind(this)

});

riot.tag2('groupy', '<div class="xcolumns"> <div class="xcolumn is-half-desktop" riot-style="padding-left:{title_style}px">{dimensions[0]} <a onclick="{recursive}" class="button is-small is-pulled-right">CSV</a> <a onclick="{expandAll}" class="button is-small is-pulled-right">+</a> <a onclick="{closeAll}" class="button is-small is-pulled-right">-</a> <span> <a href="#" class="button is-small" onclick="{setSort(\'_id\',1)}"> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'_id\' && state.order==1}"></i> </a> <a href="#" class="button is-small" onclick="{setSort(\'_id\',-1)}"> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'_id\' && state.order==-1}"></i> </a> </span> </div> <div class="xcolumn metric">req. <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'requests\' && state.order==1}" onclick="{setSort(\'requests\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'requests\' && state.order==-1}" onclick="{setSort(\'requests\',-1)}"></i> </span> </div> <div class="xcolumn metric">imp. <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'impressions\' && state.order==1}" onclick="{setSort(\'impressions\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'impressions\' && state.order==-1}" onclick="{setSort(\'impressions\',-1)}"></i> </span> </div> <div class="xcolumn metric">clk. <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'clicks\' && state.order==1}" onclick="{setSort(\'clicks\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'clicks\' && state.order==-1}" onclick="{setSort(\'clicks\',-1)}"></i> </span> </div> <div class="xcolumn metric">conv. <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'conversions\' && state.order==1}" onclick="{setSort(\'conversions\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'conversions\' && state.order==-1}" onclick="{setSort(\'conversions\',-1)}"></i> </span> </div> <div class="xcolumn metric">ctr <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'ctr\' && state.order==1}" onclick="{setSort(\'ctr\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'ctr\' && state.order==-1}" onclick="{setSort(\'ctr\',-1)}"></i> </span> </div> </div> <virtual each="{datalist}"> <div class="expandable xcolumns" onclick="{expand}"> <div class="xcolumn is-half-desktop" riot-style="padding-left:{title_style}px"> {getValue(_id) || \'(empty)\'} <span onclick="{togglePin(dimensions[0],_id)}" class="{has-text-danger: state.pinned==_id}">&#x25cf;</span> <br> <small> {getTitle(_id).slice(0,100)} <a if="{getLink(_id)}" href="{getLink(_id)}" target="_blank"><i class="fa fa-external-link-alt" aria-hidden="true"></i> edit</a> </small> </div> <div class="xcolumn metric" title="{percent(requests_invalid,requests+requests_invalid)}">{Math.round(requests).toLocaleString()}<br><span>{requests_invalid}({percent(requests_invalid,requests+requests_invalid)})</span> </div> <div class="xcolumn metric" title="{percent(impressions_invalid,impressions+impressions_invalid)}">{Math.round(impressions).toLocaleString()}<br><span>{impressions_invalid} ({percent(impressions_invalid,impressions+impressions_invalid)})</span> </div> <div class="xcolumn metric">{clicks.toLocaleString()}<br><span>{clicks_invalid} ({percent(clicks_invalid,clicks+clicks_invalid)})</span> </div> <div class="xcolumn metric">{conversions.toLocaleString()}<br><span>{conversions_invalid} ({percent(conversions_invalid,conversions+conversions_invalid)})</span> </div> <div class="xcolumn metric">{ctr.toFixed(3)}</div> </div> <groupy if="{state.expanded[_id]}" start="{start}" end="{end}" dimensions="{makeDimensions(_id)}" filter="{makeFilter(_id)}" path="{makePath(_id)}" id="{_id}"> </groupy> </virtual>', '', '', function(opts) {
  var self = this,
      dimensions = self.dimensions = opts.dimensions || [],
      dim = dimensions[0],
      topstate = self.parent.state,
      state = topstate[dim] = topstate[dim] || {
        expanded: {},
        pinned: false,
        sortby: '_id',
        order: 1
      };

  self.state = state
  self.state.collection = topstate.collection

  self.percent = (s,t) => t ? (100*s/t).toFixed(2)+'%' : '0%'

  self.on('mount',function() {
    self.start = opts.start
    self.end = opts.end
    self.dimensions = dimensions || []
    self.datalist = []
    self.path = opts.path || []
    self.filter = opts.filter || {
      $and: [
        {'_id.date':{$gte:self.start}},
        {'_id.date':{$lte:self.end}},
      ]
    }
    if (state.pinned) self.filter[dim] = state.pinned
    console.log('index',self.dimensions)
    if (self.dimensions.indexOf('_id.doc')!=0) {
      if (!self.filter['_id.doc']) self.filter['_id.doc'] = 'null'
    } else delete self.filter['_id.doc']

    self.title_style = self.parent.title_style + 30
    self.dimension_service = self.parent.dimension_service
    self.dimension_names = new Map()
    self.dimension_titles = new Map()
    self.dimension_links = new Map()
    self.loadData(true)
    if (self.parent.datalist && self.parent.datalist.length) {
    console.log('parent datalist',self.parent.datalist,self)
	    self.parentItem = self.parent.datalist.find(d => d._id==self.opts.id)
	  	self.parentItem.sub = self
	  }
	  console.log('mounted',self)
  })

  self.on('unmount',function() {
    if (self.parentItem) self.parentItem.sub = null
  })

  self.on('filter',function(opts) {
    self.start = opts.start
    self.end = opts.end+'T23:59:59'
    self.dimensions = opts.dimensions || []
    self.filter.$and = [
      {'_id.date':{$gte:self.start}},
      {'_id.date':{$lte:self.end}},
    ]
    if (self.dimensions.indexOf('_id.doc')!=0) {
      if (!self.filter['_id.doc']) self.filter['_id.doc'] = 'null'
    } else delete self.filter['_id.doc']
    self.state.collection = self.parent.state.collection
    console.log('updating',self)
    self.loadData(true)
  })

  this.setSort = function(dim,ord) {
  	return function(e) {
  		e.preventDefault()
  		state.sortby = dim
  		state.order = ord
  		e.preventUpdate = true
  		self.loadData()
  	}
  }.bind(this)

  self.on('update',function(e) {
    self.datalist.forEach(d => d.ctr=d.impressions && (100*d.clicks/d.impressions) || 0)
    self.datalist.sort( (a,b) => {
      var id = state.sortby,
      		ord = state.order,
	       	aa = id=='_id' ?  self.getValue(a[id]) : +a[id],
	       	bb = id=='_id' ?  self.getValue(b[id]) : +b[id]

      if (aa<bb) return -ord
      if (aa>bb) return ord
      return 0
    })

  })

  this.expand = function(e) {
    var dims = self.makeDimensions(e.item._id)
    if (!dims.length) return
    state.expanded[e.item._id] = !state.expanded[e.item._id]
  }.bind(this)

  this.expandAll = function(e) {
    if (self.dimensions.length==1) return
    self.datalist.forEach(d => state.expanded.set(d._id,true))
    const tags = self.tags.groupy || [];
    for (let i=0;i<tags.length;i++) tags[i].expandAll()
  }.bind(this)

  this.closeAll = function(e) {
    state.expanded = {}
  }.bind(this)

  this.togglePin = function(dim,value) {
    return function(e) {
      e.preventDefault()
      e.stopPropagation()
      var old = state.pinned
      if (old == value) {
        state.expanded[value] = state.pinned = false
        delete self.filter[dim]
      } else {
        state.expanded[value] = true
        self.filter[dim] = state.pinned = value
      }
      e.update = false
      self.loadData()
    }
  }.bind(this)

  this.makeDimensions = function(_id) {
    var dims = self.dimensions
    return dims.slice(1)
  }.bind(this)

  this.makeFilter = function(_id) {
    var f = {}, dim = self.dimensions[0], val = _id
    if (dim=='_id.hour') {
      dim = '_id.date'
      val = _id
    }
    if (dim=='_id.date') {
      dim = '_id.date'
      val = {$gte:_id,$lte:_id+'T23:59:59'}
    }
    if (dim=='_id.month') {
      var m = _id.split('-')
      if (12==m[1]) {m[1]=1; ++m[0]}
      else ++m[1]
      dim = '_id.date'
      val = {$gte:_id,$lte:m.join('-')}
    }
    if (dim=='_id.week') {
      dim = '_id.date'
      var start = new Date(_id),
          end = new Date(_id);
      end.setDate(end.getDate() + 7)
      start = start.toISOString().substr(0,10)
      end = end.toISOString().substr(0,10)
      val = {$gte:start+'T00:00:00',$lt:end+'T00:00:00'}
    }
    f[dim] = val
    return Object.assign({},self.filter,f)
  }.bind(this)
  this.makePath = function(_id) {
    var p = {}
    p[self.dimensions[0]] = self.getValue(_id)
    return Object.assign({},self.path,p)
  }.bind(this)

  this.getValue = function(id) {
    if (!id) return '(empty)'
    return self.dimension_names.get(id) || id
  }.bind(this)
  this.getTitle = function(id) {

    id = id.toString()
    return self.dimension_titles.get(id) || ''
  }.bind(this)
  this.getLink = function(id) {

    id = id.toString()
    return self.dimension_links.get(id) || ''
  }.bind(this)

  function doLoad(dim,service,dropNull) {
    var services = getCollectionNames(self.start,self.end)
    api.service('aggregate').find({
      query:{
        service: services,
        pipe: [
          {$match: self.filter},
          {$group: self.group},
          {$sort: { _id: -1 }},
      ]},
    }).then( r => {
      console.log('aggregate result',r);
      preloader.dec()
      if (dropNull) r = r.filter(d => d._id!='null')
      self.datalist = r
      if (r.length==0) state.expanded = {}
      if (self.dimension_service[dim]) {
        const
          ids = r.filter( d => ['null','other','undefined'].indexOf(d._id)<0).map(d => (service.oid ? {_oid:d._id} : d._id) )
console.log('dimension service',dim,self.dimension_service[dim])
console.log('dim ids',dim,ids.length,service)
        preloader.inc()
        return service.action(ids,self.filter)
      } else return []
    }).then(r => {
      preloader.dec()
console.log('imension names',r)
      r.forEach(d => self.dimension_names.set(d._id.toString(),d.name) )
      r.forEach(d => self.dimension_titles.set(d._id.toString(),d.title) )
      r.forEach(d => self.dimension_links.set(d._id.toString(),d.link) )
      self.update()
    }).catch( e => {
      preloader.dec()
      console.log('error aggregate',e);
      self.error = e.message
      self.update()
    })
  }

  function getCollectionNames(start = new Date(), end = new Date()) {
    start = new Date(start);
    end = new Date(end);
    let d = new Date(start.getFullYear(), start.getMonth());
    let months = [];
    while (d <= end) {
      months.push('counters_' + d.getFullYear() + '_' + (1+d.getMonth()));
      d.setMonth(d.getMonth() + 1);
    }
    return months;
  }

  this.loadData = function() {
    const
      dim = self.dimensions[0],
      service = self.dimension_service[dim],
      dropNull = !self.filter['_id.doc'];

    self.group = {
      "_id": dim=='_id.date'
             ? { $substr: [ "$_id.date", 0, 10 ] }
             : dim=='_id.month'
               ? { $substr: [ "$_id.date", 0, 7 ] }
               : dim=='_id.hour'
                 ? "$_id.date"
                 : dim=='_id.week'
                   ? { $substr: [{ $dateTrunc: {date:{$dateFromString:{dateString:{$substr:["$_id.date",0,10]},format:"%Y-%m-%d" }},unit:"week"} },0,10] }
                   : "$" + dim,
      "requests":{$sum:'$req_count'},
      "impressions":{$sum:'$imp_count'},
      "clicks":{$sum:'$clk_count'},
      "conversions":{$sum:'$cnv_count'},
      "requests_invalid":{$sum:'$req_count_invalid'},
      "impressions_invalid":{$sum:'$imp_count_invalid'},
      "clicks_invalid":{$sum:'$clk_count_invalid'},
      "conversions_invalid":{$sum:'$cnv_count_invalid'},
    }

    console.log('load data',self.filter,self.group);

    preloader.inc()

    var user = api.get('user')
    if (user && (user.roles || []).indexOf('admin')<0) {
     api.service('campaigns').find()
     .then(campaigns => {
     console.log('have campaigns',campaigns)
      var campaignIds = campaigns.data.map(c =>c._id)
      self.filter.$and.push({'_id.campaign':{$in:campaignIds}})
      return doLoad(dim,service,dropNull)
     })
     .catch(e => {
      console.log('error loading cmapaign ids',e)
     })
    } else {
      doLoad(dim,service,dropNull)
    }

  }.bind(this)

  function saveAs (filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  this.download = function(e) {
    e.preventDefault()
    var s = self,
        dim = s.dimensions[0],
        file = dim+'_'+s.start+'-'+s.end+'.csv',
        head = [dim,'requests','requests_invalid','impressions','impressions_invalid','clicks','clicks_invalid','conversions','conversions_invalid','ctr'],
        data = s.datalist.map(d => [s.getValue(d._id),d.requests,d.requests_invalid,d.impressions,d.impressions_invalid,
                                    d.clicks,d.clicks_invalid,d.conversions,d.conversions_invalid,
                                    d.impressions && (100*d.clicks/d.impressions) || 0] )
    data.unshift(head)
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
  }.bind(this)

  function dfs(node,len,depth) {
    var rows = []
    node.datalist.forEach(sub => {
      var row = new Array(len).fill(''),
          title = node.getTitle(sub._id),
          lbl = node.getValue(sub._id);
      if (title) lbl = title.slice(0,50) + '\n' + lbl
      row[depth] = lbl
      row = row.concat([sub.requests,sub.requests_invalid,sub.impressions,sub.impressions_invalid,sub.clicks,sub.clicks_invalid,sub.conversions,sub.conversions_invalid,sub.ctr])
      rows.push(row)
      if (sub.sub) rows = rows.concat(dfs(sub.sub,len,depth+1))
    })
    return rows
  }

  this.recursive = function(e) {
    var data = dfs(self,self.dimensions.length,0),
        file = (opts.path && Object.values(opts.path).join('-') || 'Table')
               + '_'
               + self.dimensions.join('-').replace(/_id\./g,'')
               + '_'
               + self.start + '-' + self.end + '.csv',
        head = [...self.dimensions,'requests','requests_invalid','impressions','impressions_invalid','clicks','clicks_invalid','conversions','conversions_invalid','ctr']

    data.unshift(head)
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
    console.log('subnodes',Object.values(self.filter),data)
  }.bind(this)

});

